import PropTypes from 'prop-types';
import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import devLogger from 'react-utils/devLogger';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ message: string; }' is not ass... Remove this comment to see the full error message
    devLogger.warn({
      message: 'Error boundary triggered'
    });
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ message: any; }' is not assign... Remove this comment to see the full error message
    devLogger.warn({
      message: error
    });
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ message: any; }' is not assign... Remove this comment to see the full error message
    devLogger.warn({
      message: info
    });
    this.setState({
      hasError: true
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return children;
    }
    return /*#__PURE__*/_jsxs(ErrorMessage, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "UP_FRONT_REQUEST_ERROR"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.errors.renderError"
      })]
    });
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};